const call_restaurant = `Hei, haluaisin tehdä varauksen illalliselle kolmelle hengelle tälle viikonlopulle.
Voisitko kertoa minulle, jos sinulla on vapaata perjantaina klo 20?
Milloin ravintola sulkeutuu päivällisen jälkeen?
Ja kuinka paljon se maksaisi 3 hengelle.
Kiitos.`;

export default call_restaurant;